import { useFormikContext } from 'formik';
import styles from './CheckBox.module.css';

interface CheckBoxProps {
  name: string;
  label: string;
}

export function CheckBox({ name, label }: CheckBoxProps) {
  const { setFieldValue, values } = useFormikContext<Record<string, boolean>>();

  return (
    <label className={styles.container}>
      <input
        type="checkbox"
        checked={values[name] || false}
        onChange={(e) => setFieldValue(name, e.target.checked)}
        className={styles.checkbox}
      />
      <span className={styles.label}>{label}</span>
    </label>
  );
}

export default CheckBox;
